import type { SwitchProps } from '@chakra-ui/react'
import { Flex, FormLabel, Switch } from '@chakra-ui/react'
import type { FieldPath, FieldValues, UseFormRegisterReturn } from 'BrokerTsLib/src/rhf'
import { forwardRef } from 'react'

export const SwitchInput = forwardRef(function SwitchInput<TFieldValues extends FieldValues, TFieldName extends FieldPath<TFieldValues>>({ gap, children, ...rest }: UseFormRegisterReturn<TFieldName> & SwitchProps & { gap?: number, children: React.ReactNode }, ref: React.Ref<HTMLInputElement>) {
  return (
    <Flex gap={gap ?? 4} alignItems='center'>
      <Switch id={rest.name} {...rest} ref={ref} />
      <FormLabel fontSize={rest.size} htmlFor={rest.name} >{children}</FormLabel>
    </Flex>
  )
})
